<template>
  <div class="floor-solution floorColor floor-cont-height">
    <div>
      <div data-aos="fade-up">
        <div class="title">{{retailArr.title}}</div>
        <div style="font-size: 16px; color: #595859; line-height: 21px">
          {{ retailArr.text}}
        </div>
      </div>
      <div class="solution-container" data-aos="fade-up">
        <div
          v-for="(item, index) in retailArr.solutionList"
          :key="index"
          class="solution-item"
          :style="{height: retailArr.height}"
        >
          <div class="solution-item-top">
            <img :src="item.image" alt="" />
            <div class="solution-item-block"></div>
          </div>
          <div class="solution-item-title">
            {{ item.title }}
          </div>
          <div class="solution-item-content" v-html="item.content">
         
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>

export default {
  name: "floor2",
  components: {
  },
  props: {
    retailArr: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      // solutionList: [
      //   {
      //     image: require("@/assets/solution/numOne.png"),
      //     title: "拓展新机会，驱动增长",
      //     content:
      //       "通过网络化、数字化手段整合产业链上下游资源，帮助企业开拓新的业务模式和市场。",
      //   },
      //   {
      //     image: require("@/assets/solution/numTwo.png"),
      //     title: "全链路重塑，降本增效",
      //     content:
      //       "实现信息的实时流通和透明化管理，优化供应链管理，减少中间环节，降低交易成本。",
      //   },
      //   {
      //     image: require("@/assets/solution/numThr.png"),
      //     title: "打造产业生态，优势共享",
      //     content:
      //       "促进了不同企业和机构间的协作和资源共享，构建互利共赢的合作模式。",
      //   },
      // ],
    };
  },
  methods: {
    // 当鼠标进入元素时触发
    // handleMouseEnter(index) {
    //   // console.log('鼠标进入了元素' + index);
    //   this.industrySelecedIndex = index;
    // },
    // 当鼠标离开元素时触发
    // handleMouseLeave(index) {
    //   // console.log('鼠标离开了元素');
    // },
  },
};
</script>

<style lang="less" scoped>
.floor-solution {
  width: 100%;
  height: 920px;
  background: #fff;
}
.floor-solution .title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  padding-top: 80px;
  margin-bottom: 14px;
}
.floor-solution .industry-container {
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-solution .industry-container img {
  width: 100%;
}

.floorColor {
  background: #f4f5fb;
}
.floor-cont-height {
  height: 750px;
}
.floor-solution .solution-container {
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.floor-solution .solution-item {
  width: 380px;
  height: 360px;
  text-align: left;
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;
}
.floor-solution .solution-item-top {
  position: relative;
}
.floor-solution .solution-item-block {
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 1)
  );
  width: 100%;
  height: 20px;
  border-radius: 6px 6px 0 0;
}
.floor-solution .solution-item-top img {
  width: 100%;
}
.floor-solution .solution-item-title {
  padding: 0 20px;
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 20px;
  margin-top: 16px;
}
.floor-solution .solution-item-content {
  padding: 0 20px;
  font-size: 14px;
  color: #222222;
  line-height: 22px;
}
</style>
